import React, { useEffect, useState, useContext, useRef } from "react";
import "./FloatingWindow.scss";
import { Paper, IconButton, Divider, CircularProgress } from "@mui/material"; // Añadimos LinearProgress para la barra
import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from "react-i18next";
import AppContext from "../../Contexts/AppContext";
import { motion, AnimatePresence } from "framer-motion";

import { DefaultSelection } from "./Components/DefaultSelection";
import { FeatureForm } from "./Components/FeatureForm/FeatureForm";
import { OverflowTooltip } from "../../CustomComponents/OverflowTooltip/OverflowTooltip";
import { CarbonFeatureFormPt } from "./Components/CarbonFeatureForm/CarbonFeatureFormPt";
import { CarbonFeatureFormSp } from "./Components/CarbonFeatureForm/CarbonFeatureFormSp";
// import { CarbonFeatureFormSp } from "./Components/CarbonFeatureForm/CarbonFeatureFormSp";
// import { CarbonFeatureForm } from "./Components/CarbonFeatureForm/CarbonFeatureFormPt";

const FloatingWindow = ({ content, onClose, open }) => {
  const childRef = useRef();
  const { t } = useTranslation("main");
  // const { t } = useTranslation("main");
  const {
    loadingClick,
    openDrawer,
    modeOptions,
    removeHighlightLayer,
    resetModeOptions,
    project,
    showTutorialCarbonWindow,
  } = useContext(AppContext);

  // Estado para controlar la visibilidad hasta que la animación termine
  const [isVisible, setIsVisible] = useState(open);

  const isMobile = window.innerWidth < 960;
  const isRotated = window.innerWidth > window.innerHeight;

  useEffect(() => {
    if (!showTutorialCarbonWindow) {
      setIsVisible(false);
    }
  }, [showTutorialCarbonWindow]);

  useEffect(() => {
    if (open) {
      setIsVisible(true);
    }
  }, [open]);

  useEffect(() => {
    if (!loadingClick && content.length === 0) {
      setIsVisible(false);
    }
  }, [content]);

  const handleClose = () => {
    setIsVisible(false);
    removeHighlightLayer();
    // if (modeOptions.ADD_POLYGON.length > 0) resetModeOptions();
  };

  const handleCloseChild = () => {
    if (childRef.current && typeof childRef.current.function === "function") {
      childRef.current.function();
    } else {
      setIsVisible(false);
    }
  };

  const asbestos_view =
    modeOptions.ASBESTOS_CLICK.length !== 0 &&
    typeof content[0]?.view?.find === "function" &&
    content[0]?.view?.find((el) => el[0].layer_type === "AMIANTO_CENSO")[0];

  const title =
    modeOptions.ADD_POLYGON.length > 0
      ? t("add_new_feature")
      : modeOptions.ASBESTOS_CLICK.length > 0
        ? `${t("edit_feature")}${
            asbestos_view?.properties?.status
              ? ` - ${asbestos_view?.properties?.status}`
              : ""
          }${
            asbestos_view?.properties?.address
              ? ` - ${asbestos_view?.properties?.address}`
              : ""
          }`
        : project?.category === "CARBON_SINK"
          ? t("area_properties")
          : t("selected_point");

  console.log("content", content);

  const foms = {
    CARBON_SINK: CarbonFeatureFormPt,
    CARBON_SINK_SP: CarbonFeatureFormPt,
    // CARBON_SINK_SP: CarbonFeatureFormSp,
    CARBON_SINK_PT: CarbonFeatureFormPt,
  };

  const CarbonFeatureForm = foms[project?.category] || CarbonFeatureFormPt;

  return (
    <AnimatePresence onExitComplete={onClose}>
      {isVisible && (
        <motion.div
          initial={{ x: "100vw" }} // Empieza fuera de la pantalla a la derecha
          animate={{ x: 0 }} // Llega a su posición final
          exit={{ x: "100vw" }} // Se desliza fuera al cerrar
          transition={{
            type: "spring",
            stiffness: 100,
            damping: 15, // Controla el rebote
          }}
          style={{
            position: "fixed",
            top: "15vh",
            right: "1rem",
            height: "70vh",
            width: "40rem",
            maxWidth: openDrawer ? "calc(0.9 * calc(100vw - 450px))" : "90vw",
            zIndex: 99,
          }}
        >
          <Paper
            className="selection-details"
            style={{ overflow: isMobile && isRotated ? "auto" : "hidden" }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: "3rem",
                paddingBottom: "1rem",
                position: "relative",
              }}
            >
              <OverflowTooltip text={title} />
              <IconButton
                style={{
                  margin: "-8px",
                }}
                onClick={handleCloseChild}
              >
                <CloseIcon />
              </IconButton>
            </div>
            <Divider />
            {loadingClick ? (
              <div
                style={{
                  maxHeight: "373.06px",
                  height: "373.06px",
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CircularProgress />
              </div>
            ) : modeOptions.ASBESTOS_CLICK.length > 0 ? (
              <FeatureForm
                content={content}
                onClose={handleClose}
                ref={childRef}
              />
            ) : modeOptions.CARBON_SINK.length > 0 ? (
              // project.category === "CARBON_SINK" ? (
              <CarbonFeatureForm
                // content={content}
                onClose={handleClose}
                // onClose={() => {
                //   removeHighlightLayer();
                //   setIsVisible(false);
                // }}
                ref={childRef}
              />
            ) : // ) : (
            modeOptions.ADD_POLYGON.length > 0 ? (
              <FeatureForm
                content={[
                  {
                    view: [
                      [
                        {
                          layer_type: "AMIANTO_CENSO",
                          properties: {
                            // uuid: modeOptions.ADD_POLYGON[0],
                            inspection_type: "PRELIMINAR",
                            element_type: "CUBIERTA",
                            is_asbestos: "MPCA",
                          },
                        },
                      ],
                    ],
                  },
                ]}
                onClose={handleClose}
                ref={childRef}
              />
            ) : (
              // )
              <DefaultSelection content={content} />
            )}
          </Paper>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export { FloatingWindow };
